import type { UserCurrency } from '@/services/domain/user/types'
import type { RegisteredServices } from '@/core/container/types'
import type {
  ImportMatchingCountrySharedData,
  ImportMatchingSharedData,
  ImportProgressSharedData,
  ImportUploadSharedData,
} from '@/components/shared/import/upload/types'
import type { ImportSessionPreviewMappingItem } from '@/data/repositories/domain/import/types'
import type { LookupFlowPreview } from '@/services/domain/lookup/types'

export type LookupResponse = {
  price: number
  currency: UserCurrency
}

export const CarrierLookupSessionTableId = 'carrierLookupSessionTable' as RegisteredServices

export const carrierLookupFlowStepVariant = ['upload', 'matching', 'preview', 'progress'] as const
export type CarrierLookupFlowStep = (typeof carrierLookupFlowStepVariant)[number]

export type CarrierLookupFlowSharedData = ImportUploadSharedData<LookupFlowPreview> &
  ImportMatchingSharedData &
  ImportMatchingCountrySharedData &
  ImportProgressSharedData

export type CarrierLookupImportProcess = {
  mapping: ImportSessionPreviewMappingItem[]
  country?: string
  // excludeFirstRow?: boolean // TODO: uncomment when BE is ready
}
